// extracted by mini-css-extract-plugin
export default {"actions":"UsersTableHead_actions__ZlyFx"};